"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryAndRegionDTO = exports.SettlementsListDTO = exports.SettlementDTO = exports.GetCountryAndRegionDTO = exports.GetClosestSettlementsDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GeoIp_1 = require("./GeoIp");
let GetClosestSettlementsDTO = (() => {
    class GetClosestSettlementsDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], GetClosestSettlementsDTO.prototype, "mapCoordinates", void 0);
    return GetClosestSettlementsDTO;
})();
exports.GetClosestSettlementsDTO = GetClosestSettlementsDTO;
let GetCountryAndRegionDTO = (() => {
    class GetCountryAndRegionDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], GetCountryAndRegionDTO.prototype, "mapCoordinates", void 0);
    return GetCountryAndRegionDTO;
})();
exports.GetCountryAndRegionDTO = GetCountryAndRegionDTO;
class SettlementDTO {
}
exports.SettlementDTO = SettlementDTO;
class SettlementsListDTO {
}
exports.SettlementsListDTO = SettlementsListDTO;
class CountryAndRegionDTO {
}
exports.CountryAndRegionDTO = CountryAndRegionDTO;
//# sourceMappingURL=Osm.js.map